import RequiredValidator from "@/validators/RequiredValidator";

export default class ShipmentTypeRules {

	public static readonly deliveryMethod = [
		(new RequiredValidator('shipmentType.deliveryMethod')).validationRule(),
	];
}
